// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark Mode CSS Variables */
:root {
  /* Light Mode Colors */
  --bg-primary: #ffffff;
  --bg-secondary: #f8fafc;
  --bg-tertiary: #e2e8f0;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-tertiary: #94a3b8;
  --border-primary: #e2e8f0;
  --border-secondary: #cbd5e1;
  --shadow-primary: rgba(0, 0, 0, 0.1);
  --shadow-secondary: rgba(0, 0, 0, 0.05);
  /* Marken-Palette: Ocean/Turtle – Teal + Meerblau statt generischem Blau/Violett */
  --accent-primary: #0d9488;
  --accent-secondary: #0ea5e9;
  --accent-hover: #0f766e;
  --brand-deep: #0b3b52;
  --success: #10b981;
  --warning: #f59e0b;
  --error: #ef4444;
  --gradient-primary: linear-gradient(135deg, #0d9488 0%, #0ea5e9 100%);
  --gradient-secondary: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.dark {
  /* Dark Mode Colors */
  --bg-primary: #0f172a;
  --bg-secondary: #1e293b;
  --bg-tertiary: #334155;
  --text-primary: #f1f5f9;
  --text-secondary: #cbd5e1;
  --text-tertiary: #94a3b8;
  --border-primary: #334155;
  --border-secondary: #475569;
  --shadow-primary: rgba(0, 0, 0, 0.4);
  --shadow-secondary: rgba(0, 0, 0, 0.3);
  --accent-primary: #2dd4bf;
  --accent-secondary: #38bdf8;
  --accent-hover: #14b8a6;
  --brand-deep: #0b3b52;
  --success: #34d399;
  --warning: #fbbf24;
  --error: #f87171;
  --gradient-primary: linear-gradient(135deg, #2dd4bf 0%, #38bdf8 100%);
  --gradient-secondary: linear-gradient(135deg, #1e293b 0%, #334155 100%);
}

/* Apply CSS Variables */
body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Global Dark Mode Styles */
.dark {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

.dark * {
  border-color: var(--border-primary);
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

::-webkit-scrollbar-thumb {
  background: var(--border-secondary);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--text-tertiary);
}

.dark ::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

.dark ::-webkit-scrollbar-thumb {
  background: var(--border-secondary);
}

.dark ::-webkit-scrollbar-thumb:hover {
  background: var(--text-tertiary);
}
`, "",{"version":3,"sources":["webpack://./src/styles/dark-mode.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;EAC3B,oCAAoC;EACpC,uCAAuC;EACvC,kFAAkF;EAClF,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qEAAqE;EACrE,uEAAuE;AACzE;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;EAC3B,oCAAoC;EACpC,sCAAsC;EACtC,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qEAAqE;EACrE,uEAAuE;AACzE;;AAEA,wBAAwB;AACxB;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,4BAA4B;AAC5B;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* Dark Mode CSS Variables */\r\n:root {\r\n  /* Light Mode Colors */\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #f8fafc;\r\n  --bg-tertiary: #e2e8f0;\r\n  --text-primary: #1e293b;\r\n  --text-secondary: #64748b;\r\n  --text-tertiary: #94a3b8;\r\n  --border-primary: #e2e8f0;\r\n  --border-secondary: #cbd5e1;\r\n  --shadow-primary: rgba(0, 0, 0, 0.1);\r\n  --shadow-secondary: rgba(0, 0, 0, 0.05);\r\n  /* Marken-Palette: Ocean/Turtle – Teal + Meerblau statt generischem Blau/Violett */\r\n  --accent-primary: #0d9488;\r\n  --accent-secondary: #0ea5e9;\r\n  --accent-hover: #0f766e;\r\n  --brand-deep: #0b3b52;\r\n  --success: #10b981;\r\n  --warning: #f59e0b;\r\n  --error: #ef4444;\r\n  --gradient-primary: linear-gradient(135deg, #0d9488 0%, #0ea5e9 100%);\r\n  --gradient-secondary: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\r\n}\r\n\r\n.dark {\r\n  /* Dark Mode Colors */\r\n  --bg-primary: #0f172a;\r\n  --bg-secondary: #1e293b;\r\n  --bg-tertiary: #334155;\r\n  --text-primary: #f1f5f9;\r\n  --text-secondary: #cbd5e1;\r\n  --text-tertiary: #94a3b8;\r\n  --border-primary: #334155;\r\n  --border-secondary: #475569;\r\n  --shadow-primary: rgba(0, 0, 0, 0.4);\r\n  --shadow-secondary: rgba(0, 0, 0, 0.3);\r\n  --accent-primary: #2dd4bf;\r\n  --accent-secondary: #38bdf8;\r\n  --accent-hover: #14b8a6;\r\n  --brand-deep: #0b3b52;\r\n  --success: #34d399;\r\n  --warning: #fbbf24;\r\n  --error: #f87171;\r\n  --gradient-primary: linear-gradient(135deg, #2dd4bf 0%, #38bdf8 100%);\r\n  --gradient-secondary: linear-gradient(135deg, #1e293b 0%, #334155 100%);\r\n}\r\n\r\n/* Apply CSS Variables */\r\nbody {\r\n  background-color: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n/* Global Dark Mode Styles */\r\n.dark {\r\n  background-color: var(--bg-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.dark * {\r\n  border-color: var(--border-primary);\r\n}\r\n\r\n/* Scrollbar Styling */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--border-secondary);\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--text-tertiary);\r\n}\r\n\r\n.dark ::-webkit-scrollbar-track {\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.dark ::-webkit-scrollbar-thumb {\r\n  background: var(--border-secondary);\r\n}\r\n\r\n.dark ::-webkit-scrollbar-thumb:hover {\r\n  background: var(--text-tertiary);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
